// Wrapper class for a javascript File object or a server file json. Seems that Vue can't observe native js File objects
class FileObject {
  constructor (file) {
    let attributes = file.attributes || file;
    this._file = file;
    this.id = attributes.id || file.id;
    this.status = attributes.status;
    this.processing_status = attributes.processing_status
    this.name = attributes.name;
    this.asset_url = attributes.asset_url;
    this.progress = 0;
    this.removing = false;
    this.error = null;
    this.status = null; // can be error/success/null
    this.canRetry = true; // set it to false to disable upload retrying
    this.presignData = attributes.presignData
  }
}

FileObject.createFromList = function(files) {
  return files.map(f => {
    if (f instanceof FileObject) {
      return f;
    } else {
      return new FileObject(f)
    }
  })
};

FileObject.SUCCESS = 'success';
FileObject.ERROR = 'error';
FileObject.UPLOADING = 'uploading';

export default FileObject